var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0909 0C11.3727 0 9.87873 0.805851 9 2.15631C8.12127 0.805851 6.62727 0 4.90909 0C3.60758 0.00157648 2.35982 0.540004 1.43951 1.49717C0.519209 2.45433 0.00151577 3.75208 0 5.10571C0 7.59049 1.48909 10.1765 4.42636 12.7907C5.77232 13.9835 7.2262 15.0379 8.76764 15.9392C8.83907 15.9791 8.9189 16 9 16C9.08109 16 9.16093 15.9791 9.23236 15.9392C10.7738 15.0379 12.2277 13.9835 13.5736 12.7907C16.5109 10.1765 18 7.59049 18 5.10571C17.9985 3.75208 17.4808 2.45433 16.5605 1.49717C15.6402 0.540004 14.3924 0.00157648 13.0909 0ZM9 14.901C7.65736 14.0952 0.981818 9.84722 0.981818 5.10571C0.982901 4.02276 1.39701 2.98449 2.13329 2.21873C2.86956 1.45297 3.86785 1.02227 4.90909 1.02114C6.56836 1.02114 7.96173 1.94272 8.54591 3.42678C8.58289 3.52043 8.64581 3.60052 8.72667 3.65689C8.80752 3.71326 8.90266 3.74335 9 3.74335C9.09734 3.74335 9.19248 3.71326 9.27333 3.65689C9.35419 3.60052 9.41711 3.52043 9.45409 3.42678C10.0383 1.94272 11.4316 1.02114 13.0909 1.02114C14.1322 1.02227 15.1304 1.45297 15.8667 2.21873C16.603 2.98449 17.0171 4.02276 17.0182 5.10571C17.0182 9.84722 10.3426 14.0952 9 14.901Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.d32603b0b5f663dc8205c0e2cee29bdc.svg";
export { ForwardRef as ReactComponent };